import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow teams.
 */
export class TeamOperations {
  constructor(private client: BaserowClient) {}
  
  // Team methods will be implemented here
} 